import { Injectable } from '@angular/core';
import { SharedConstants } from '@formbird/types';
import { Notyf } from 'notyf';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notyf: any;
  private queue = [];
  private currentMessage = {};
  private _scope = null;
  private count = 0;
  private msgObj = [];

  constructor() {
    this.notyf = new Notyf({
      ripple: false,
      types: [
        {
          type: 'warning',
          className: 'notyf-warning',
          icon: {
            className: 'material-icons',
            tagName: 'i',
            text: 'warning'
          }

        },
        {
          type: 'info',
          className: 'notyf-info',
          dismissible: true,
          icon: {
            className: 'material-icons',
            tagName: 'i',
            text: 'info'
          }
        }
      ]
    });
  }

  /**
   * init listener for close button
   * @param msgObj the message obj
   */
  private initBtnClose(msgObj) {

    for (let j = 0; j < msgObj.length; j++) {

      const closeBtnId = msgObj[j].closeId;

      const elm = document.getElementById(closeBtnId);

      if (elm) {

        elm.addEventListener('click', function(data: any) {

          setTimeout(function() {

            const closedId = data.target.id;

            for (let i = 0; i < msgObj.length; i++) {

              if (msgObj[i].closeId === closedId) {
                msgObj.splice(i, 1);
                break;
              }
            }

            this.updateDisplayAlert(msgObj);
          }, 100);
        });
      }
    }
  }

  /**
   * build alert msg body
   * @param type the style
   * @param id the id
   * @param title the title
   * @param msg the mssage
   * @param opts the options
   * @returns string
   */
  private buildAlert(type, id, title, msg, opts) {
    const alertId = 'alertId' + id;
    const closeBtnId = 'closeId' + id;
    let msgTemplate = '<div class="alert ' + type + ' fade in" id="' + alertId + '" >';

    if (opts.closeButton) {
      msgTemplate += '<button type="button" class="close" data-dismiss="alert" aria-hidden="true" id="' + closeBtnId + '">' +
        '&times;</button>';
    }

    msgTemplate += '<span><strong>' + title + '!</strong> ' + msg + '</span></div>';

    return msgTemplate;
  }

  /**
   * Update the latest msg on screen
   * @param msgObj the message obj
   */
  private updateDisplayAlert(msgObj) {

    for (let j = 0; this._scope && j < this._scope.MaxAlertMessages.length; j++) {

      const alertPlaceholderId = this._scope.MaxAlertMessages[j];
      const obj = msgObj[j];
      const msg = obj ? obj.msg : '';
      $('#' + alertPlaceholderId).html(msg);

    }

    this.initBtnClose(msgObj);
  }


  /**
   * Show alert using bootstrap library
   * @param type - type of alert
   * @param msg - body message of alert
   * @param title - title of alert
   * @param opts - alert's options
   */
  private showAlert(type, msg, title, opts) {

    if (this._scope
      && this.count >= this._scope.MaxAlertMessages.length
      && this.msgObj.length === this._scope.MaxAlertMessages.length) {

      this.msgObj.splice(0, 1);

    }

    const obj = {
      alertId: 'alertId' + this.count,
      closeId: 'closeId' + this.count,
      msg: this.buildAlert(type, this.count, title, msg, opts)
    };

    this.msgObj.push(obj);
    this.updateDisplayAlert(this.msgObj);

    if (opts.timeOut) {

      setTimeout(function() {

        for (let i = 0; i < this.msgObj.length; i++) {

          const object = this.msgObj[i];
          const alertId = object.alertId;

          $('#' + alertId).fadeTo(2000, 500).slideUp(500, function() {
            $('#' + alertId).alert('close');
          });
        }

        this.count = 0;
        this.msgObj = [];
      }, opts.timeOut);
    }

    this.initBtnClose(this.msgObj);

    this.count++;
  }


  /**
   * position:
   *     { x: 'right', y: 'top' }
   *     { x: 'center', y: 'top' }
   *     { x: 'left', y: 'top' }
   *     { x: 'right', y: 'bottom' }
   *     { x: 'center', y: 'bottom' }
   *     { x: 'left', y: 'bottom' }
   *      /**
   *(e.g) position: { x: 'right', y: 'top' }
   *     notyf position options
   *     Param |       Type                | Details
   *     x     |  left ; center or right  | x-position
   *     y     | top  ; center or bottom  |  y-position
   */
  private printNotyfMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut) {
    if (!messageType) {
      messageType = SharedConstants.STATUS_INFO;
    }

    if (!position || /^toast/.test(position)) {
      position = { x: 'right', y: 'top' };
    }

    preventDuplicate = preventDuplicate ? preventDuplicate : false;
    const notyfMessage = !(!title || title === '') ? '<i class="notyf-message-type">[' + messageType + ']</i><b>' +
      title + '</b> <br/>' + message : message;
    const lowerCaseMessageType = messageType.toLowerCase();
    /** preventDuplicate condition
     * if value is true, do not display duplicate notification
     * if value is false, display duplicate notification
     **/
    if (preventDuplicate) {
      const notyfTextContent = this.notyf.view.container.textContent;
      let compareMessage = !(!title || title === '') ? '[' + messageType + ']' + title + ' ' + message : message;
      if (lowerCaseMessageType === 'warning') {
        compareMessage = 'warning' + compareMessage;
      } else if (lowerCaseMessageType === 'info') {
        compareMessage = 'info' + compareMessage;
      }
      /**The message is duplicate if notyfTextContent.split(compareMessage).length greater than 1
       * The message is duplicate if preventDuplicate value is true and
       * [title, message and messageType] are similar with new notification message
       * */
      if (notyfTextContent.split(compareMessage).length > 1) {
        if (lowerCaseMessageType === 'success') {
          console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #3dc663;color:white`);
        } else if (lowerCaseMessageType === 'info') {
          console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: blue;color:white`);
        } else if (lowerCaseMessageType === 'warning') {
          console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: orange;color:white`);
        } else if (lowerCaseMessageType === 'error') {
          console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #ed3d3d;color:white`);
        } else if (lowerCaseMessageType === 'forbidden') {
          console.log('%cDuplicate ' + lowerCaseMessageType + ' notification: ' + notyfMessage, `background: #ed3d3d;color:white`);
        }
        return;
      }
    }

    switch (lowerCaseMessageType) {
      case SharedConstants.STATUS_SUCCESS:
        this.notyf.open({ type: 'success', duration: timeOut, message: notyfMessage, dismissible: true, position: position });
        break;
      case SharedConstants.STATUS_INFO:
        this.notyf.open({ type: 'info', duration: timeOut, message: notyfMessage, dismissible: true, position: position });
        break;
      case SharedConstants.STATUS_WARNING:
        this.notyf.open({ type: 'warning', duration: timeOut, message: notyfMessage, dismissible: true, position });
        break;
      case SharedConstants.STATUS_ERROR:
        this.notyf.open({ type: 'error', message: notyfMessage, duration: timeOut, dismissible: true, position: position });
        break;
      case SharedConstants.STATUS_FORBIDDEN:
        this.notyf.error({ message: notyfMessage, duration: timeOut, dismissible: true, position: position });
        break;
    }
  }

  private printPermanentMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut) {
    if (!messageType) {
      messageType = SharedConstants.STATUS_INFO;
    }

    const alertOptions = {
      closeButton: true
    };

    if (!title) {
      title = messageType;
    }

    const lowerCaseMessageType = messageType.toLowerCase();
    switch (lowerCaseMessageType) {
      case SharedConstants.STATUS_SUCCESS:
        this.showAlert('alert-success', message, title, alertOptions);
        break;
      case SharedConstants.STATUS_INFO:
        this.showAlert('alert-info', message, title, alertOptions);
        break;
      case SharedConstants.STATUS_WARNING:
        this.showAlert('alert-warning', message, title, alertOptions);
        break;
      case SharedConstants.STATUS_ERROR:
        this.showAlert('alert-danger', message, title, alertOptions);
        break;
      case SharedConstants.STATUS_FORBIDDEN:
        this.showAlert('alert-danger', message, title, alertOptions);
        break;
    }
  }

  /**
   * position:
   *     { x: 'right', y: 'top' }
   *     { x: 'center', y: 'top' }
   *     { x: 'left', y: 'top' }
   *     { x: 'right', y: 'bottom' }
   *     { x: 'center', y: 'bottom' }
   *     { x: 'left', y: 'bottom' }
   *      /**
   *(e.g) position: { x: 'right', y: 'top' }
   *     notyf position options
   *     Param |       Type                | Details
   *     x     |  left ; center or right  | x-position
   *     y     | top  ; center or bottom  |  y-position
   */
  private printHTML5Notification(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut) {
    (<any>window).Notification.requestPermission(function(permission) {

      let icon;
      const lowerCaseMessageType = messageType.toLowerCase();

      switch (lowerCaseMessageType) {
        case SharedConstants.STATUS_SUCCESS:
          icon = './images/notifications/success.png';
          break;
        case SharedConstants.STATUS_INFO:
          icon = './images/notifications/info.png';
          break;
        case SharedConstants.STATUS_WARNING:
          icon = './images/notifications/warning.png';
          break;
        case SharedConstants.STATUS_ERROR:
          icon = './images/notifications/error.png';
          break;
        case SharedConstants.STATUS_FORBIDDEN:
          icon = './images/notifications/warning.png';
          break;

      }

      const notification = new (<any>window).Notification('Formbird', {
        body: message,
        icon: icon,
        dir: 'auto'
      });

      notification.onclick = function() {
        onClickFunction();
      };

      setTimeout(function() {
        notification.close();
      }, timeOut);
    });
  }

  /**
   * Display both messages
   */
  public printMessage(message, messageType?, title?, position?, preventDuplicate?, displayDesktopNotification?,
                      onClickFunction?, timeOut?, isPermanent?) {

    if (!timeOut) {
      timeOut = 3000;
    }

    if (!onClickFunction) {
      onClickFunction = function() {
      };
    }

    if (displayDesktopNotification) {
      this.printHTML5Notification(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut);
    }
    if (isPermanent) {
      this.printPermanentMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut);
    }

    this.printNotyfMessage(message, messageType, title, position, preventDuplicate, onClickFunction, timeOut);
  }

  public set(message) {
    const msg = message;
    this.queue.push(msg);
  }

  public get() {
    return this.currentMessage;
  }

  public error(message, title?, displayDesktopNotification?) {

    const messageType = SharedConstants.STATUS_ERROR;
    const position = '';
    const preventDuplicate = false;
    const onClickFunction = null; // leave this undefined so the default will be used
    const timeOut = 0;
    const isPermanent = true; // make errors permanent so the user will see them if they miss the temporary popup

    this.printMessage(message, messageType, title, position, preventDuplicate, displayDesktopNotification,
      onClickFunction, timeOut, isPermanent);
  }

  public forbidden(message, title?, displayDesktopNotification?) {
    if (!title) {
      title = 'Forbidden';
    }

    this.error(message, title, displayDesktopNotification);
  }

  public info(message, title?, displayDesktopNotification?) {
    this.printMessage(message, SharedConstants.STATUS_INFO, title, '', undefined, displayDesktopNotification);
  }

  public success(message, title?, displayDesktopNotification?) {
    this.printMessage(message, SharedConstants.STATUS_SUCCESS, title, '', undefined, displayDesktopNotification);
  }

  public warning(message, title?, displayDesktopNotification?) {
    this.printMessage(message, SharedConstants.STATUS_WARNING, title, '', undefined, displayDesktopNotification);
  }

  public setupAlert(scope, maxAlertMessages) {
    this._scope = scope;
    this._scope.MaxAlertMessages = [];
    if (!maxAlertMessages) {
      maxAlertMessages = 5;
    }
    for (let i = 0; i < maxAlertMessages; i++) {
      const alertPlaceholderId = 'alert_placeholder_' + i;
      this._scope.MaxAlertMessages.push(alertPlaceholderId);
    }

  }

  public reverseSetupAlert() {
    if (this._scope != null && this._scope.MaxAlertMessages != null) {
      delete this._scope.MaxAlertMessages;
    }
  }
}
